// ApplicationDashboard.js
import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboard,
  faCheckSquare,
  faFile,
  faHourglass,
  faPiggyBank,
  faClock,
  faGavel,
  faShareSquare,
  faRemoveFormat,
  faHome,
} from "@fortawesome/free-solid-svg-icons";
import {
  Col,
  Row,
  Breadcrumb,
  Button,
  Modal,
  Table,
} from "@themesberg/react-bootstrap";
import axios from "axios";
import  "./DashboardOverview.css";
import ChartistGraph from "react-chartist";
import CounterWidget from "../../components/CounterWidget";
import BASE_URL from "../../config";


const ApplicationDashboard = () => {
  const [applicationCounts, setApplicationCounts] = useState({});
  const [applications, setApplications] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [modalApplications, setModalApplications] = useState([]);

  const totalApplications =
    (applicationCounts.newApplications || 0) +
    (applicationCounts.applied || 0) +
    (applicationCounts.incomplete || 0) +
    (applicationCounts.waitingMerchant || 0) +
    (applicationCounts.waitingBank || 0) +
    (applicationCounts.waitingAgent || 0) +
    (applicationCounts.approved || 0) +
    (applicationCounts.declined || 0) +
    (applicationCounts.suspended || 0);

  const applicationChartData = {
    labels: [
      "New",
      "Applied",
      "Incomplete",
      "Merchant",
      "Bank",
      "Agent",
      "Approved",
      "Declined",
      "Suspended",
    ],
    series: [
      [
        applicationCounts.newApplications || 0,
        applicationCounts.applied || 0,
        applicationCounts.incomplete || 0,
        applicationCounts.waitingMerchant || 0,
        applicationCounts.waitingBank || 0,
        applicationCounts.waitingAgent || 0,
        applicationCounts.approved || 0,
        applicationCounts.declined || 0,
        applicationCounts.suspended || 0,
      ],
    ],
  };

  const applicationChartOptions = {
    height: "350px",
    low: 0,
    axisY: {
      onlyInteger: true,
      offset: 45,
    },
    axisX: {
      showGrid: false,
      offset: 45,
    },
    chartPadding: {
      top: 20,
      right: 20,
      bottom: 10,
      left: 10,
    },
  };
  // Fetch application counts and details
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("authToken"));
    const fetchApplicationData = async () => {
      try {
        const response = await axios.get(`${BASE_URL}/api.php?type=applicationCounts`, {
          headers: {
            email: user.email,
            user_type: user.user_type,
          },
        });

        setApplicationCounts(response.data.counts);
        setApplications(response.data.applications);
      } catch (error) {
        console.error("Error fetching application data:", error);
      }
    };

    fetchApplicationData();
  }, []);

  // Show modal with applications for a selected status
  const handleShowModal = (statusKey, statusName) => {
    setModalTitle(statusName);

    setModalApplications(applications[statusKey] || []);
    setShowModal(true);
  };

  // Close the modal
  const handleCloseModal = () => {
    setShowModal(false);
    setModalTitle("");
    setModalApplications([]);
  };

  const handleRowClick = (id) => {
    const query = new URLSearchParams({ id }).toString();
    window.location.href = `/#/application?applicationId=${id}`; 
   };
  
  

  return (
    <>
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center mt-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb
            className="d-none d-md-inline-block"
            listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}
          >
            <Breadcrumb.Item>
              <FontAwesomeIcon icon={faHome} />
            </Breadcrumb.Item>
            <Breadcrumb.Item active>Applications</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Applications</h4>
        </div>
      </div>

      <Row className="justify-content-md-center text-center">
        <Col xs={12} sm={6} xl={4} className="mb-4  " role="button">
          <CounterWidget
            category="New Applications"
            title={applicationCounts.newApplications}
            icon={faClipboard}
            iconColor="primary"
            onClick={() =>
              handleShowModal("newApplications", "New Applications")
            }
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4" role="button">
          <CounterWidget
            category="Application Applied"
            title={applicationCounts.applied}
            icon={faCheckSquare}
            iconColor="primary"
            onClick={() => handleShowModal("applied", "Application Applied")}
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4" role="button">
          <CounterWidget
            category="Incomplete Application"
            title={applicationCounts.incomplete}
            icon={faFile}
            iconColor="primary"
            onClick={() =>
              handleShowModal("incomplete", "Incomplete Application")
            }
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4" role="button">
          <CounterWidget
            category="Waiting For Merchant"
            title={applicationCounts.waitingMerchant}
            icon={faHourglass}
            iconColor="primary"
            onClick={() =>
              handleShowModal("waitingMerchant", "Waiting For Merchant")
            }
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4" role="button">
          <CounterWidget
            category="Waiting For Bank"
            title={applicationCounts.waitingBank}
            icon={faPiggyBank}
            iconColor="primary"
            onClick={() => handleShowModal("waitingBank", "Waiting For Bank")}
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4" role="button">
          <CounterWidget
            category="Waiting For Agent"
            title={applicationCounts.waitingAgent}
            icon={faClock}
            iconColor="primary"
            onClick={() => handleShowModal("waitingAgent", "Waiting For Agent")}
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4" role="button">
          <CounterWidget
            category="Application Approved"
            title={applicationCounts.approved}
            icon={faGavel}
            iconColor="primary"
            onClick={() => handleShowModal("approved", "Application Approved")}
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4" role="button">
          <CounterWidget
            category="Application Declined"
            title={applicationCounts.declined}
            icon={faShareSquare}
            iconColor="primary"
            onClick={() => handleShowModal("declined", "Application Declined")}
          />
        </Col>

        <Col xs={12} sm={6} xl={4} className="mb-4" role="button">
          <CounterWidget
            category="Application Suspended"
            title={applicationCounts.suspended}
            icon={faRemoveFormat}
            iconColor="primary"
            onClick={() =>
              handleShowModal("suspended", "Application Suspended")
            }
          />
        </Col>
      </Row>
      <Row>
        <Col xs={12} className="mb-4">
          <div
            className="card application-chart-card"
            style={{
              border: "none",
              borderRadius: "16px",
              boxShadow: "0 4px 20px rgba(0, 0, 0, 0.08)",
              overflow: "hidden",
            }}
          >
            {/* Chart Header */}
            <div
              className="card-body"
              style={{
                padding: "24px 28px 10px 28px",
              }}
            >
              <div className="d-flex justify-content-between align-items-center flex-wrap">
                <div>
                  <h5
                    className="mb-1"
                    style={{
                      fontWeight: "700",
                      fontSize: "20px",
                    }}
                  >
                    Application Overview
                  </h5>

                  <p
                    className="text-muted mb-0"
                    style={{
                      fontSize: "14px",
                    }}
                  >
                    Applications by current status
                  </p>
                </div>

                <div
                  style={{
                    padding: "10px 18px",
                    borderRadius: "12px",
                    background: "#f5f7ff",
                    textAlign: "center",
                    minWidth: "130px",
                  }}
                >
                  <div
                    style={{
                      fontSize: "12px",
                      color: "#6c757d",
                      fontWeight: "500",
                    }}
                  >
                    Total Applications
                  </div>

                  <div
                    style={{
                      fontSize: "25px",
                      fontWeight: "700",
                      marginTop: "2px",
                    }}
                  >
                    {totalApplications}
                  </div>
                </div>
              </div>

              {/* Chart */}
              <div
                style={{
                  marginTop: "25px",
                  width: "100%",
                }}
              >
                <ChartistGraph
                  data={applicationChartData}
                  options={applicationChartOptions}
                  type="Bar"
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Modal to display applications for the selected status */}
      <Modal show={showModal} onHide={handleCloseModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>{modalTitle}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {modalApplications.length > 0 ? (
            <Table striped bordered hover>
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Number</th>
                </tr>
              </thead>
              <tbody>
  {modalApplications.map((app, index) => (
    <tr
      key={index}
      onClick={() => handleRowClick(app.id)} // Add onClick to the row
      style={{ cursor: 'pointer' }} // Change cursor to pointer for better UX
    >
      <td>{app.id}</td>
      <td>{app.contactname}</td>
      <td>{app.contactemail}</td>
      <td>{app.tollfreeno}</td>
    </tr>
  ))}
</tbody>


            </Table>
          ) : (
            <p>No applications available for this status.</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ApplicationDashboard;
